import { useMemo } from 'react';
import { useEnhancedCompany } from '../contexts/EnhancedCompanyContext';

/**
 * Live company profile for display, dates, exports, and letterheads.
 * Use `currentCompany` from the same hook for companyId / auth / Firestore paths.
 */
export function useActiveCompanyProfile() {
  const ctx = useEnhancedCompany();
  const { currentCompany, activeCompanyProfile, companyInfo } = ctx;
  const profile = useMemo(
    () => activeCompanyProfile || companyInfo || currentCompany || null,
    [activeCompanyProfile, companyInfo, currentCompany]
  );
  return {
    ...ctx,
    profile,
    companyProfile: profile,
  };
}

export default useActiveCompanyProfile;
